import { useState, MouseEventHandler } from 'react';

import AddLocationIcon from '@mui/icons-material/AddLocation';
import ChevronRightIcon from '@mui/icons-material/ChevronRight';
import EditLocationAltIcon from '@mui/icons-material/EditLocationAlt';
import {
    MenuItem,
    ListItemIcon,
    Box,
    Menu,
    TextField,
    Stack,
    Button,
} from '@mui/material';
import { useForm } from 'react-hook-form';

type MarkerCreatorProps = {
    onCreate?: (coords: [number, number]) => void;
    onClose?: () => void;
    disabled?: boolean;
    coords?: [number, number];
};

export const MarkerCreator = ({
    onCreate = () => undefined,
    onClose = () => undefined,
    disabled,
    coords,
}: MarkerCreatorProps): JSX.Element => {
    const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);

    const open = Boolean(anchorEl);

    const handleMenuClick: MouseEventHandler<HTMLLIElement> = (e) => {
        setAnchorEl(e.currentTarget);
    };
    const handleClose = (): void => {
        setAnchorEl(null);
        onClose();
    };

    const {
        register,
        handleSubmit,
        formState: { errors },
    } = useForm<{ x: number; y: number }>({
        defaultValues: coords
            ? {
                  x: coords[1],
                  y: coords[0],
              }
            : undefined,
    });

    const onSubmit = handleSubmit((data) => onCreate([data.y, data.x]));

    return (
        <div>
            <MenuItem
                onClick={(e) => {
                    handleMenuClick(e);
                }}
                selected={open}
                disabled={disabled}
            >
                <ListItemIcon sx={{ mx: -1 }}>
                    {coords ? <EditLocationAltIcon /> : <AddLocationIcon />}
                </ListItemIcon>
                {coords ? 'Изменить расположение' : 'Добавить маркер'}
                <Box sx={{ ml: 'auto', display: 'flex', alignItems: 'center' }}>
                    <ChevronRightIcon sx={{ mr: -2, ml: 2 }} color="action" />
                </Box>
            </MenuItem>
            <Menu
                anchorEl={anchorEl}
                open={open}
                onClose={() => {
                    handleClose();
                }}
                anchorOrigin={{ horizontal: 'right', vertical: 'top' }}
                PaperProps={{
                    sx: {
                        p: 1,
                    },
                }}
            >
                <Stack
                    direction="row"
                    component="form"
                    onSubmit={onSubmit}
                    spacing={1}
                >
                    <TextField
                        placeholder="Широта (N)"
                        variant="outlined"
                        size="small"
                        type="number"
                        inputProps={{
                            step: '0.0001',
                        }}
                        {...register('x', {
                            required: true,
                            valueAsNumber: true,
                        })}
                        error={!!errors.x}
                    />
                    <TextField
                        placeholder="Долгота (E)"
                        variant="outlined"
                        size="small"
                        type="number"
                        inputProps={{
                            step: '0.0001',
                        }}
                        {...register('y', {
                            required: true,
                            valueAsNumber: true,
                        })}
                        error={!!errors.y}
                    />
                    <Button
                        variant="outlined"
                        type="submit"
                        size="small"
                        disabled={!!Object.keys(errors).length}
                    >
                        {coords ? 'Сохранить' : 'Добавить'}
                    </Button>
                </Stack>
            </Menu>
        </div>
    );
};
